import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PRELOADER_MS = 1300;

function scrollToHashElement(hash) {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return false;
  let id;
  try {
    id = decodeURIComponent(raw);
  } catch {
    id = raw;
  }
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "auto", block: "start" });
  return true;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const run = () => scrollToHashElement(hash);
    run();
    const t0 = window.setTimeout(run, 0);
    const t1 = window.setTimeout(run, PRELOADER_MS);

    return () => {
      window.clearTimeout(t0);
      window.clearTimeout(t1);
    };
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
